import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import 'hammerjs';

if (environment.production) {
  enableProdMode();
}

String.prototype.toProperCase = function(this : string) {
  let s = this;

  if (!s) return s;

  let cased = s.replace(/\b(\w)(.*?)\b/g, function (match, p1, p2) {
    if (/^[Ii]+$/.test(match)) {
      return match.toUpperCase();
    } else {
      return p1.toUpperCase() + p2.toLowerCase();
    }
  });

  return cased;
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));



// WEBPACK FOOTER //
// ./src/main.ts